import ApiClient from "_config/client";

export const setProductRequest = (cabinetId) =>
  ApiClient.post("/cabinet/" + encodeURIComponent(cabinetId) + "/select", null);
